import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidenav from "../../shared/Sidebar";
import Navbar from "../../shared/Topnav";
import "./index.css";


export default function DashboardLayout() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [theme, setTheme] = useState("light");
  const [isHovered, setIsHovered] = useState(false);

  const toggleSidebar = () => {
    if (window.innerWidth <= 768) {
      setIsMobileOpen(!isMobileOpen); // mobile
    } 
    else if(window.innerWidth <= 1024) {
      
      setIsTablet(!isTablet); 

    }
    else {
      setIsCollapsed(!isCollapsed); 
    }
  };

  console.log(window.innerWidth);
  

  const toggleTheme = () => {
    setTheme(prev => (prev === "light" ? "dark" : "light"));
  };

  useEffect(() => {
    document.body.classList.remove("light", "dark");
    document.body.classList.add(theme);
  }, [theme]);

  return (
    <div className="dashboard-layout">

      {/* Sidebar */}
      <Sidenav
        isCollapsed={isCollapsed}
        isMobileOpen={isMobileOpen}
        closeMobile={() => setIsMobileOpen(false)}
         isHovered={isHovered}
          onMouseEnter={() => setIsHovered(true)}
  onMouseLeave={() => setIsHovered(false)}
  
      />

      {/* Main */}
     <div
  className={`main-section ${
    isCollapsed && !isHovered ? "collapsed" : ""
  }`}
>
        <Navbar
          toggleSidebar={toggleSidebar}
          toggleTheme={toggleTheme}
          theme={theme}
          
        />

        <main className="content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}